export default __webpack_public_path__ + "static/advanced-1m-d92847700fb41d49839553ca0410e31e.webp";